import { ACTION_SET_LIVE_COUNT, ACTION_SET_LIVE_PAGEVIEWS, ACTION_SET_LIVE_CONTENTS } from "../action";

const reduceLive = (state = {
	count: 0,
	pageviews: {},
	contents:{},
}, action)=>{
	switch (action.type) {
		case ACTION_SET_LIVE_COUNT:
			return {
				...state,
				count: action.payload,
			};
		case ACTION_SET_LIVE_PAGEVIEWS:
			return {
				...state,
				pageviews: action.payload,
			};
		case ACTION_SET_LIVE_CONTENTS:
			return {
				...state,
				contents: action.payload,
			};
	}
	return state;
};

export default reduceLive;
